import { useMemo } from 'react';

import { SLUG_PRODUCT_URL_PARAM } from '~constants';

interface UseSlugProductModeResult {
  slugProduct: string | undefined;
  isSlugProductMode: boolean;
}

/**
 * Hook to detect "slug-product" URL mode.
 * When a slug-product param is in the URL, the configurator shows only the targeted product.
 */
const useSlugProductMode = (): UseSlugProductModeResult => {
  const slugProduct = useMemo(() => {
    const searchParams = new URL(globalThis.location.href).searchParams;
    return searchParams.get(SLUG_PRODUCT_URL_PARAM) ?? undefined;
  }, []);

  return {
    isSlugProductMode: !!slugProduct,
    slugProduct,
  };
};

export default useSlugProductMode;
